import { render, staticRenderFns } from "./feedbackSubmit.vue?vue&type=template&id=6c1d8a9a&scoped=true&"
import script from "./feedbackSubmit.vue?vue&type=script&lang=js&"
export * from "./feedbackSubmit.vue?vue&type=script&lang=js&"
import style0 from "./feedbackSubmit.vue?vue&type=style&index=0&id=6c1d8a9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1d8a9a",
  null
  
)

export default component.exports